export default "__VITE_ASSET__Dkdqpd1f__"